// eslint-disable-next-line no-unused-vars
const types = {
	INIT_CALL: 'Init Call',
	END_CALL: 'End Call',
	CALLCENTER_UPDATE: 'Call Center update'
}

const mapNotificationsResult = ({ data, totalCount }) => {
	const mappedData = data.map((item) => {
		return {
			id: item.id,
			type: item.type,
			phoneNumber: item.phoneNumber,
			customerPhoneNumber: item.customerPhoneNumber,
			sentAt: item.sentAt,
			isSent: item.isSent,
			item,
		}
	});
	return {
		data: mappedData,
		total: totalCount,
	};
};

export {
	mapNotificationsResult,
};
